// extracted by mini-css-extract-plugin
export default {"section-title":"TitleSection_section-title__kc6rh","title":"TitleSection_title__KjpdV","custom-padding":"TitleSection_custom-padding__vpfvU"};